<div class="container greyTextContainer">
  <h1>Make a Complaint</h1>

  <p>
    Here are ADIEM, we welcome any feedback or complaints. In fact, to give you
    better services, we need your feedback.
  </p>
  <p>Feedback can be compliments, comments or complaints.</p>
  <p>
    We love to hear compliments. That means we are getting it right. If you are
    happy, we are happy!
  </p>
  <p>
    If you are not happy, tell us. It's OK to complain. We won't be angry. So
    don't be shy. We need to know how you feel. Help us to do better!
  </p>
  <p>We will always listen and reply to complaints, as quickly as possible.</p>
  <p>
    You can complain anonymously. If you don't leave your name, we can't reply
    to your complaint. But we will still try to make things better.
  </p>
  <p>
    We really want to hear what you have to say, whether it's to tell us you are
    not happy with the service you are getting or how we can be better at what
    we do.
  </p>
  <h3>What is a complaint?</h3>
  <p>
    Broadly speaking, a complaint is an expression of dissatisfaction with any
    NDIS support or service, including how a previous complaint was handled, for
    which a response or resolution is explicitly or implicitly expected. If you
    have a problem with the services and/or supports you are getting from us and
    you want it fixed, you can make a complaint.
  </p>
  <h3>How do I make a complaint?</h3>
  <p>You can make a complaint in the best way that works for you. You can:</p>
  <ul>
    <li>Talk to us directly if you feel comfortable.</li>
    <li>Call the ADIEM office on 0407 838 657.</li>
    <!-- <li>Write to ADIEM at 4 O'Shannasy Street, MULGRAVE VIC 3170.</li> -->
    <li>
      Email ADIEM at
      <a href="mailto:complaints@adiem.com.au?subject=Complaint:"
        >complaints&#64;adiem.com.au</a
      >.
    </li>
    <li>
      Fill in the complaint form below. You do not have to include your name if
      you don't want to.
    </li>
  </ul>
  <br />

  <br />
  <div class="formContainer">
    <h3 class="title">Complaint Form</h3>
    <form [formGroup]="complaintForm">
      <div class="singleRow">
        <!-- FIRST NAME -->
        <mat-form-field appearance="fill" color="primary">
          <mat-label>First Name</mat-label>
          <input
            #nameFirst
            type="text"
            formControlName="nameFirst"
            matInput
            placeholder="Enter first name"
          />
          <mat-error *ngIf="f.nameFirst.touched && f.nameFirst.errors">
            <mat-error *ngIf="f.nameFirst.errors.required">
              First name is required
            </mat-error>
            <mat-error *ngIf="f.nameFirst.errors.notAllLetters">
              First name must be letters, spaces and hyphens only
            </mat-error>
          </mat-error>
        </mat-form-field>

        <!-- LAST NAME -->
        <mat-form-field appearance="fill">
          <mat-label>Last Name</mat-label>
          <input
            #nameLast
            type="text"
            formControlName="nameLast"
            matInput
            placeholder="Enter last name"
          />
          <mat-error *ngIf="f.nameLast.touched && f.nameLast.errors">
            <mat-error *ngIf="f.nameLast.errors.required">
              Last name is required
            </mat-error>
            <mat-error *ngIf="f.nameLast.errors.notAllLetters">
              Last name must be letters, spaces and hyphens only
            </mat-error>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="singleRow">
        <!-- PHONE -->
        <mat-form-field appearance="fill">
          <mat-label>Phone No.</mat-label>
          <input
            #phone
            type="text"
            formControlName="phone"
            matInput
            placeholder="Enter preferred phone number"
          />
          <mat-error *ngIf="f.phone.touched && f.phone.errors">
            <mat-error *ngIf="f.phone.errors.required">
              Phone is required
            </mat-error>
            <mat-error *ngIf="f.phone.errors.wrongFormat">
              Phone must be numbers only in Australian format
            </mat-error>
            <mat-error *ngIf="f.phone.errors.min">
              Not enough numbers
            </mat-error>
            <mat-error *ngIf="f.phone.errors.max"> Too many numbers </mat-error>
          </mat-error>
        </mat-form-field>

        <!-- EMAIL -->
        <mat-form-field appearance="fill">
          <mat-label>Email Address</mat-label>
          <input
            #email
            type="email"
            formControlName="email"
            matInput
            placeholder="Enter email address"
            required
          />
          <mat-error *ngIf="f.email.touched && f.email.errors">
            <mat-error *ngIf="f.email.errors.required">
              Email is required
            </mat-error>
            <mat-error *ngIf="f.email.errors && !f.email.errors.required">
              Email isn't in the correct format
            </mat-error>
          </mat-error>
        </mat-form-field>
      </div>

      <!-- I AM A ... -->
      <mat-form-field appearance="fill">
        <mat-label>I am a:</mat-label>
        <mat-select #whoAmI formControlName="whoAmI" required>
          <mat-option>Please choose...</mat-option>
          <mat-option value="Person with a disability"
            >Person with a disability</mat-option
          >
          <mat-option value="Support Coordinator"
            >Support Coordinator</mat-option
          >
          <mat-option value="Plan Nominee">Plan Nominee</mat-option>
          <mat-option value="Family member or friend"
            >Family member or friend</mat-option
          >
          <mat-option value="Disability provider"
            >Disability provider</mat-option
          >
          <mat-option value="Disability worker">Disability worker</mat-option>
          <mat-option value="Advocate">Advocate</mat-option>
          <mat-option value="Carer">Carer</mat-option>
          <mat-option value="Anonymous">Anonymous</mat-option>
        </mat-select>
        <mat-error
          *ngIf="f.whoAmI.touched && f.whoAmI.errors"
          class="UserTypeRequired"
        >
          <mat-error *ngIf="f.whoAmI.errors.required">
            Please choose
          </mat-error>
        </mat-error>
      </mat-form-field>

      <!-- ON BEHALF -->
      <p class="margin-top">
        Are you making this complaint on behalf of a person with disability?
      </p>
      <mat-radio-group
        class="margin-bottom"
        color="accent"
        aria-label="Select an option"
        #onBehalfOfDisability
        required
        formControlName="onBehalfOfDisability"
      >
        <mat-radio-button value="On behalf of a person with a disability"
          >Yes</mat-radio-button
        >
        <mat-radio-button
          class="ml-40"
          value="Not on behalf of a person with a disability"
          >No</mat-radio-button
        >
        <mat-error
          *ngIf="
            f.onBehalfOfDisability.touched && f.onBehalfOfDisability.errors
          "
          class="UserTypeRequired"
        >
          <mat-error *ngIf="f.onBehalfOfDisability.errors.required">
            <hr
              style="
                height: 2px;
                width: 100%;
                margin: 0;
                border-width: 0;
                color: red;
                background-color: red;
              "
            />
            <span class="errorFont">Please choose</span>
          </mat-error>
        </mat-error>
      </mat-radio-group>

      <br />

      <!-- <p>Please write your complaint below.</p> -->

      <!-- COMPLAINT -->
      <mat-form-field>
        <mat-label>Tell us about your complaint...</mat-label>
        <textarea
          class="textareaHeight"
          #complaint
          matInput
          type="textarea"
          formControlName="complaint"
          required
        ></textarea>
        <mat-error *ngIf="f.complaint.touched && f.complaint.errors">
          <mat-error *ngIf="f.complaint.errors.required">
            A complaint is required
          </mat-error>
          <mat-error *ngIf="f.complaint.errors.notAllowed">
            Only letters, numbers and basic punctuation allow
          </mat-error>
        </mat-error>
      </mat-form-field>

      <!-- FURTHER IMPROVEMENT -->
      <mat-form-field>
        <mat-label
          >Is there any further action you would like us to take?</mat-label
        >
        <textarea
          class="textareaHeight"
          #furtherImprovement
          matInput
          type="textarea"
          formControlName="furtherImprovement"
        ></textarea>
        <mat-error
          *ngIf="f.furtherImprovement.touched && f.furtherImprovement.errors"
        >
          <mat-error *ngIf="f.furtherImprovement.errors.notAllowed">
            Only letters, numbers and basic punctuation allow
          </mat-error>
        </mat-error>
      </mat-form-field>

      <!-- ADDITIONAL NOTES -->
      <mat-form-field>
        <mat-label>Is there any additional notes you'd like to add?</mat-label>
        <textarea
          class="textareaHeight"
          #additionalNotes
          matInput
          type="textarea"
          formControlName="additionalNotes"
        ></textarea>
        <mat-error
          *ngIf="f.additionalNotes.touched && f.additionalNotes.errors"
        >
          <mat-error *ngIf="f.additionalNotes.errors.notAllowed">
            Only letters, numbers and basic punctuation allow
          </mat-error>
        </mat-error>
      </mat-form-field>

      <div class="centreButton">
        <button
          class="submitBtn"
          [class.formInvalidBtn]="complaintForm.invalid"
          mat-raised-button
          type="button"
          color="accent"
          (click)="submitForm()"
        >
          <span *ngIf="!submitted">Send Complaint</span>
          <!-- Animated Circle Submission Confirmation -->
          <div
            [ngClass]="{
              'circle-loader': submitted,
              'load-complete': delivered
            }"
          >
            <div
              class="checkmark draw"
              [ngStyle]="{ display: delivered ? 'block' : 'none' }"
            ></div>
          </div>
        </button>
      </div>

      <br />
    </form>
  </div>
</div>
